// **************************************************
// Match Height
// **************************************************

window.addEventListener('load', () => {
  equalheight('.footer__title');
});
window.addEventListener('resize', () => {
  equalheight('.footer__title');
});

// **************************************************
// Add content ID to first element after breadcrumbs
// **************************************************

window.addEventListener('DOMContentLoaded', () => {
  const mainDiv = document.querySelector('.main');
  if (mainDiv) {
    const item = document.querySelector('.main > *:first-of-type');
    const breadcrumbs = mainDiv.querySelector('.sc-breadcrumbs');

    if (item === breadcrumbs) {
      item.nextElementSibling.setAttribute('id', 'content');
      item.nextElementSibling.setAttribute('tabIndex', '1');
    } else {
      item.setAttribute('id', 'content');
      item.setAttribute('tabIndex', '1');
    }
  }

  const siteHeader = document.querySelector('.header-main');
  const wcagBtn = document.querySelector('#pojo-a11y-toolbar');
  if (siteHeader) {
    setTimeout(() => {
      document.body.append(siteHeader);
    }, 100);
  }
  if (wcagBtn) {
    setTimeout(() => {
      document.body.append(wcagBtn);
    }, 200);
  }
});
